import React from 'react';
import { SxProps, Theme } from '@mui/material/styles';
import { ArcStack, ArcText } from '@src/core/ui';
import { useNotificationDisplay } from '@src/core/features';
import { NotificationItemProps } from '../types';

const notifRowSx: SxProps<Theme> = {
  px: 2,
  py: 1.25,
  cursor: 'pointer',
  transition: (theme) =>
    theme.transitions.create('background-color', {
      duration: theme.transitions.duration.shorter,
    }),
};

const NotificationItem: React.FC<NotificationItemProps> = ({ notification, rowSx, onClick }) => {
  const { getTitle, getMessage, getTime } = useNotificationDisplay();
  const unread = !notification.read;

  return (
    <ArcStack
      direction='row'
      spacing={1}
      data-notification-item
      onClick={() => onClick?.(notification)}
      sx={{ ...notifRowSx, ...rowSx }}>
      <ArcStack spacing={0.25} flex={1}>
        <ArcText.h5 fontSize={14} fontWeight={unread ? 600 : 500}>
          {getTitle(notification)}
        </ArcText.h5>
        <ArcStack direction='row' alignItems='center' justifyContent='space-between' spacing={1}>
          <ArcText.h5 fontSize={12}>
            {getMessage(notification)}
          </ArcText.h5>
          <ArcStack
            sx={{
              mt: 0.75,
              width: 8,
              height: 8,
              flexShrink: 0,
              borderRadius: '50%',
              bgcolor: (theme) => (unread ? theme.palette.error.main : 'transparent'),
            }} />
        </ArcStack>
        <ArcText.h5 fontSize={12} color='text.secondary' sx={{ flexShrink: 0 }}>
          {getTime(notification.createdAt)}
        </ArcText.h5>
      </ArcStack>
    </ArcStack>
  );
};

export default NotificationItem;
